<template>
  <div class="main-content">
    <div class="container-fluid">
      <div class="row justify-content-center">

        <div class="col-12 col-lg-6 col-md-11 ml-4">
          <eq-window
              title="Server Listings"
              class="mt-5"
          >

            <h3 class="eq-header" style="margin: 0px" v-if="servers.length > 0">Players Online:
              {{ playersOnline.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</h3>
            <h3 class="eq-header" style="margin: 0px" v-if="servers.length > 0">Servers Online:
              {{ serversOnline.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</h3>

            <eq-tabs v-if="servers.length > 0">
              <eq-tab :name="'Servers (' + listedServers.length + ')'" :selected="true">
                <server-table-component :servers="listedServers"/>
              </eq-tab>
              <eq-tab :name="'Test & Development (' + testServers.length + ')'">
                <server-table-component :servers="testServers"/>
              </eq-tab>
            </eq-tabs>
          </eq-window>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HelloWorld           from "@/components/HelloWorld.vue";
import EqWindow             from "@/eq-ui/EQWindow.vue";
import EqTabs               from "@/eq-ui/EQTabs.vue";
import EqTab                from "@/eq-ui/EQTab.vue";
import ServerTableComponent from "@/views/ServerListings/ServerTableComponent.vue";

const BASE_URL = process.env.VUE_APP_BACKEND_BASE_URL && process.env.NODE_ENV !== "production" ?
    process.env.VUE_APP_BACKEND_BASE_URL :
    window.location.origin;

export default {
  data() {
    return {
      servers: [],
      playersOnline: 0,
      serversOnline: 0,
      listings: {},
      testServers: [],
      listedServers: [],

      refreshInterval: null
    }
  },
  components: {
    ServerTableComponent,
    EqTab,
    EqTabs,
    EqWindow,
    HelloWorld
  },
  mounted() {
    document.title = "Server Listings";
    this.$nextTick(function () {
      this.getServerList();
    });
    this.refreshInterval = setInterval(this.refreshServerList, 5000);
  },
  beforeDestroy() {
    clearInterval(this.refreshInterval)
  },
  methods: {

    refreshServerList() {
      if (document.hidden) {
        return true;
      }

      this.getServerList()
    },
    getServerList() {
      const axios = require("axios");

      axios
          .get(BASE_URL + "/servers/list")
          .then((response) => {
            // handle success
            let servers = response.data;

            servers.sort(function (a, b) {
              return (a.server_long_name < b.server_long_name) ? -1 : (a.server_long_name > b.server_long_name) ? 1 : 0;
            });

            let playersOnline = 0;
            let serversOnline = 0;
            servers.forEach((server) => {
              playersOnline += server.players_online;
              serversOnline++;
            })
            this.playersOnline = playersOnline
            this.serversOnline = serversOnline

            this.listedServers = servers.filter((server) => {
              let listedServer = !server.server_long_name.includes("|D|") &&
                  !server.server_long_name.includes("|I|") &&
                  !server.server_long_name.includes("|T|");

              server.server_long_name = server.server_long_name.replace("|*| ", "")

              return listedServer;
            });

            this.testServers = servers.filter((server) => {
              let testServer = server.server_long_name.includes("|D|") ||
                  server.server_long_name.includes("|I|") ||
                  server.server_long_name.includes("|T|");

              server.server_long_name = server.server_long_name.replace("|D| ", "")
              server.server_long_name = server.server_long_name.replace("|T| ", "")
              server.server_long_name = server.server_long_name.replace("|I| ", "")

              return testServer
            })

            this.servers = servers
          })
          .catch(function (error) {
            // handle error
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    }
  }
}

</script>

<style>

#server-listings TBODY TR TD {
  padding: 5px 5px;
}

.eq-table tr {
  border-bottom: .4px solid #ffffff1c;
}

.eq-table td {
  padding-top: 5px;
  padding-bottom: 5px;
  /*border-right:   .1px solid #ffffff1c;*/
  /*border-left:    .1px solid #ffffff1c;*/
}
</style>
